import { render } from "./OrderConfirmDialog.vue?vue&type=template&id=0bbc5723&ts=true"
import script from "./OrderConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./OrderConfirmDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/toyota/bo/merchant-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__